// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3j1uJ","title":"ClientCherryInfo_title__1Vbxo","itemText":"ClientCherryInfo_itemText__1UxPj"};